module.exports = __webpack_public_path__ + "img/31_5.c5d32cd9.png";